(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/xpert-selector/xpert-button.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/xpert-selector/xpert-button.js');
"use strict";

const ReactButton = svs.ui.ReactButton;
const Loader = svs.components.ReactLoader.Loader;
const _svs$components$lbUti = svs.components.lbUtils.reactConditionals,
  Choose = _svs$components$lbUti.Choose,
  When = _svs$components$lbUti.When,
  Otherwise = _svs$components$lbUti.Otherwise;
const XpertButton = _ref => {
  let isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    isLoading = _ref.isLoading,
    children = _ref.children;
  return React.createElement(ReactButton, {
    className: "xpert-apply-btn",
    disabled: isDisabled || isLoading,
    inverted: true,
    onClick: onClick
  }, React.createElement(Choose, null, React.createElement(When, {
    condition: isLoading
  }, React.createElement(Loader, {
    size: 200
  })), React.createElement(Otherwise, null, children)));
};
setGlobal('svs.components.tipsen.routePlaySpela.XpertButton', XpertButton);

 })(window);